import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Badge, Spinner } from "reactstrap";

const FbTokenDebugModal = ({ isOpen, toggle, debugData, loading }) => {
  const raw = debugData?.rawDebugData || {};
  const appName = debugData?.appName || raw.application || "Meta App";

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
      <ModalHeader toggle={toggle}>
        Meta Graph Token Debug & Inspection
      </ModalHeader>

      <ModalBody>
        {loading ? (
          <div className="text-center py-4">
            <Spinner color="primary" />
            <div className="mt-2 text-muted">Inspecting Token with Meta Graph API...</div>
          </div>
        ) : debugData ? (
          <div>
            <div className="d-flex align-items-center justify-content-between mb-3 pb-2 border-bottom">
              <div>
                <h5 className="mb-0">{debugData.tokenName || "Token Inspection"}</h5>
                <small className="text-muted">App Name: <strong>{appName}</strong></small>
              </div>
              <div className="d-flex gap-2">
                <Badge color={debugData.tokenType === "page" ? "warning" : "primary"} className="px-2 py-1">
                  {debugData.tokenType?.toUpperCase()}
                </Badge>
                <Badge color={debugData.isValid ? "success" : "danger"} className="px-2 py-1">
                  {debugData.isValid ? "VALID TOKEN" : "INVALID TOKEN"}
                </Badge>
              </div>
            </div>

            <div className="row g-3 mb-3">
              <div className="col-md-6">
                <strong>Token Expiration Status:</strong>
                <div className="text-primary fw-bold mt-1">
                  {debugData.expirationInfo || (raw.expires_at === 0 ? "Never Expires" : "Active")}
                </div>
              </div>

              <div className="col-md-6">
                <strong>Data Access Expiration:</strong>
                <div className="text-info fw-bold mt-1">
                  {debugData.dataAccessExpiryInfo || (raw.data_access_expires_at ? new Date(raw.data_access_expires_at * 1000).toLocaleString() : "Never Expires")}
                </div>
              </div>

              <div className="col-md-6">
                <strong>App ID:</strong>
                <div className="text-muted mt-1">{debugData.appId || raw.app_id || "N/A"}</div>
              </div>

              <div className="col-md-6">
                <strong>User / Target ID:</strong>
                <div className="text-muted mt-1">{debugData.userId || raw.user_id || "N/A"}</div>
              </div>

              {raw.issued_at && (
                <div className="col-md-6">
                  <strong>Issued Date:</strong>
                  <div className="text-muted mt-1">{new Date(raw.issued_at * 1000).toLocaleString()}</div>
                </div>
              )}

              <div className="col-md-6">
                <strong>Token Scope Type:</strong>
                <div className="text-muted mt-1">{raw.type || debugData.tokenType?.toUpperCase()}</div>
              </div>
            </div>

            {debugData.scopes && debugData.scopes.length > 0 && (
              <div className="mb-3">
                <strong>Granted Scopes & Permissions ({debugData.scopes.length}):</strong>
                <div className="d-flex flex-wrap gap-1 mt-2" style={{ maxHeight: "150px", overflowY: "auto" }}>
                  {debugData.scopes.map((scope, idx) => (
                    <Badge color="info" key={idx} className="me-1 mb-1 p-2">
                      {scope}
                    </Badge>
                  ))}
                </div>
              </div>
            )}

            {debugData.error && (
              <div className="alert alert-danger mb-3">
                <strong>Meta Error:</strong> {debugData.error.message || JSON.stringify(debugData.error)}
              </div>
            )}
          </div>
        ) : (
          <div className="text-center text-muted py-3">No Debug Data Available</div>
        )}
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default FbTokenDebugModal;
